'use client'

import { useMemo } from 'react'

import { CatalogNavigationModel } from '@marketplace-web/domain/catalog-data'
import { useCatalogContext } from '@marketplace-web/domain/catalog-page-data'

interface UseGetSubcatalogsResult {
  subCatalogs: Array<CatalogNavigationModel>
}

const useGetSubcatalogs = (): UseGetSubcatalogsResult => {
  const {
    state: { data, filters },
  } = useCatalogContext()
  const { catalogs } = data

  const subCatalogs: Array<CatalogNavigationModel> = useMemo(() => {
    const selectedCatalogs = catalogs.filter(catalog => filters.catalogIds.includes(catalog.id))

    if (selectedCatalogs.length > 0) {
      const deepestSelected = selectedCatalogs.reduce((prev, current) => {
        return (prev.depth ?? 0) > (current.depth ?? 0) ? prev : current
      }, selectedCatalogs[0] as CatalogNavigationModel)

      const { catalogIds } = deepestSelected

      return catalogs.filter(catalog => catalog.id && catalogIds.includes(catalog.id))
    }

    return catalogs.filter(catalog => catalog.depth === 0)
  }, [catalogs, filters.catalogIds])

  return { subCatalogs }
}

export default useGetSubcatalogs
